import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
 
 
export const appRoutes: Route[] = [
    // A login handoff must be reachable with or without an existing portal session.
    { path: 'login-as', component: LayoutComponent, data: { layout: 'empty' }, children: [
        { path: '', loadComponent: () => import('app/modules/auth/login-as/login-as.component').then(m => m.LoginAsComponent) }
    ] },

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'quote-requests' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'accept-invitation', loadComponent: () => import('app/modules/auth/accept-invitation/accept-invitation.component').then(m => m.AcceptInvitationComponent) },
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
        ]
    },
    {
        path: 'verify/:username/:id',
        loadComponent: () => import('app/modules/verification/verification-view/verification-view.component').then(m => m.VerificationComponent)
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            // {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'quote-requests',
                loadChildren: () => import('app/modules/shipment/shipment.routes').then(m => m.shipmentRoutes),
                canActivate: [AuthGuard],
                // data:{claimType:"canAccessPlatform"}
            },
            {
                path: 'ai-quote-request',
                loadChildren: () => import('app/modules/shipment/portal-shipment-ai/portal-shipment-ai.routes').then(m => m.default),
                canActivate: [AuthGuard],
            },
            {
                path: 'profile',
                loadComponent: () => import('app/modules/profile/profile-view/profile-view.component').then(m => m.ProfileViewComponent),
                canActivate: [AuthGuard],
                // data:{claimType:"canAccessPlatform"}
            },
            {
                path: 'dashboard',
                loadComponent: () => import('app/modules/analytics/analytics-view/analytics-view.component').then(m => m.AnalyticsViewComponent),
                canActivate: [AuthGuard],
                data: { preload: true },
                // data:{claimType:"canAccessPlatform"}
            },
            {
                path: 'inbox',
                loadComponent: () => import('app/modules/inbox/inbox-view/inbox-view.component').then(m => m.InboxViewComponent),
                canActivate: [AuthGuard],
                // data:{claimType:"canAccessPlatform"}
            },
            {
                path: 'accounting',
                loadChildren: () => import('app/modules/accounting/accounting.routes').then(m => m.accountingRoutes),
                canActivate: [AuthGuard],
                // data:{claimType:"canAccessPlatform"}
            },
        ]
    }
];
